import { useState } from 'react';
import { Building2, Coins } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const FORM_SEND_TO_SUBSIDIARIES_ID = 'form-send-to-subsidiaries';

export default function FormSendToSubsidiaries({ subsidiaries = [], onSubmit }) {
    const { t } = useTranslation();
    const [amounts, setAmounts] = useState({});

    const handleAmountChange = (subsidiaryId, value) => {
        const cleaned = value.replace(/\D/g, '');
        setAmounts((prev) => ({ ...prev, [subsidiaryId]: cleaned }));
    };

    const totalToSend = Object.values(amounts).reduce((sum, v) => sum + (parseInt(v, 10) || 0), 0);

    const handleSubmit = (e) => {
        e.preventDefault();

        const transfers = Object.entries(amounts)
            .map(([id, val]) => ({ id, amount: parseInt(val, 10) || 0 }))
            .filter((t) => t.amount > 0);

        if (transfers.length === 0) return;

        onSubmit({ transfers, totalToSend });
    };

    return (
        <form id={FORM_SEND_TO_SUBSIDIARIES_ID} onSubmit={handleSubmit} className="flex-1 overflow-y-auto p-5">
            {subsidiaries.length === 0 ? (
                <div className="flex flex-col items-center justify-center py-3 gap-3">
                    <p className="text-[14px] text-muted-foreground">{t('account:aucunSousCompte')}</p>
                </div>
            ) : (
                <div className="space-y-3">
                    {subsidiaries.map((sub) => {
                        const subId = sub.uniq_id ?? sub.id;
                        return (
                            <div key={subId} className="bg-card border border-border rounded-xl p-4">
                                {/* Subsidiary info */}
                                <div className="flex items-start justify-between mb-3">
                                    <div className="flex-1 min-w-0">
                                        <h4 className="text-[14px] text-foreground font-medium mb-1 truncate">
                                            {sub.name}
                                        </h4>
                                        <p className="text-[12px] text-muted-foreground truncate">{sub.email}</p>
                                    </div>
                                    <div className="flex items-center gap-1.5 bg-surface rounded-md px-2 py-1 shrink-0 ml-3">
                                        <Coins className="h-3 w-3 text-brand" />
                                        <span className="text-[12px] text-foreground">{sub.balance ?? 0}</span>
                                    </div>
                                </div>

                                {/* Amount input */}
                                <div>
                                    <label className="text-[12px] text-muted-foreground mb-2 block">
                                        {t('account:montantAEnvoyer')}
                                    </label>
                                    <div className="relative">
                                        <input
                                            type="text"
                                            inputMode="numeric"
                                            placeholder="0"
                                            value={amounts[subId] ?? ''}
                                            onChange={(e) => handleAmountChange(subId, e.target.value)}
                                            className="w-full bg-surface border border-border rounded-lg px-3 py-2.5 text-[14px] text-foreground placeholder:text-muted-foreground/50 focus:outline-none focus:ring-2 focus:ring-secondary focus:border-transparent"
                                        />
                                        <div className="absolute right-3 top-1/2 -translate-y-1/2 flex items-center gap-1 pointer-events-none">
                                            <Coins className="h-4 w-4 text-muted-foreground" />
                                            <span className="text-[13px] text-muted-foreground">jetons</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </form>
    );
}
